import { PersonOutlineIcon } from '@applyboard/ui-icons';
import { GridAlpha } from '@applyboard/crystal-ui';
import { useAppProcessing } from '~/pages/ApplicationDetails/context';

import { Card } from './Card';
import { LabelValue } from '~/components/uie-fix/LabelValue';
import { ChangeAgency } from './ChangeAgency';

export function AgentInformation() {
  const { application } = useAppProcessing();

  if (!application.agent) return null;

  return (
    <Card id="agentInformation" icon={PersonOutlineIcon} title="Agent Information">
      <GridAlpha rows="repeat(3, auto)" columnGap={2} rowGap={6} columns="repeat(1, 1fr)">
        <LabelValue label="AGENT NAME" value={`${application.agent?.givenName} ${application.agent?.familyName}`} />
        <LabelValue label="AGENCY NAME" value={application.agency?.agencyName} />
      </GridAlpha>

      <ChangeAgency />
    </Card>
  );
}
